import React from "react";

import Page from "../components/Page";
import ProjectsSchedule from "../components/ProjectsSchedule";

import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";

const ProjectsSchedulePage = () => (
  <Page title="Rooster projecten">
    <CenteredPageContentContainer>
      <PaperContainer title="Rooster projecten">
        <ProjectsSchedule />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default ProjectsSchedulePage;



// WEBPACK FOOTER //
// ./src/pages/ProjectsSchedulePage.js